import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { IBannerRegisterDataProps } from "../BannerRegisterData";

function bannerRegisterDataAdapter(data:any): IBannerRegisterDataProps {  

return {
    title: data.tituloGeneral ?? '',
    description: documentToReactComponents(JSON.parse(data.descripcion.raw)) ?? '',
    imagen: data.imagenPrincipal.file.url ?? '',
    ctaTitle: data.tituloBoton ?? '',
    ctaEvent: data.redireccionBoton ?? ''
};
  };
export default bannerRegisterDataAdapter;
